import styled from 'styled-components';

export const Header = styled.div`
  width: 100%;

  .header-shimmer {
    border-radius: 1rem;
    width: 100%;
    height: 3.5rem;
  }
`;

export const Content = styled.div`
  .content-shimmer {
    margin-top: 1rem;

    border-radius: 1rem;
    width: 100%;
    height: 30rem;
  }
`;

export const ShimmerEffect = styled.div`
  background-image: linear-gradient(
    -90deg,
    #f5f5f5 0%,
    #e2e2e2 50%,
    #f5f5f5 100%
  );
  background-size: 400% 400%;
  animation: shimmer 1.2s ease-in-out infinite;
  @keyframes shimmer {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }

  &.white {
    background-image: linear-gradient(
      -90deg,
      #f5f5f5 0%,
      #e2e2e2 50%,
      #f5f5f5 100%
    );
  }
`;
